import { Box, Grid, Typography, Container } from "@mui/material";
// import LeaderDisplay from "../LeaderDisplay";
// import LeaderboardRankItem from "../../components/leaderboard/LeaderboardRankItem";
import SchoolLeaderboardRankItem from "./SchoolLeaderboardRankItem";

import leaderBoardBg_1 from "../../public/leaderBoardBg_1.png";
import leaderBoardBg_2 from "../../public/leaderBoardBg_2.png";
import leaderBoardBg_3 from "../../public/leaderBoardBg_3.png";
import leaderBoardBg_4 from "../../public/leaderBoardBg_4.png";


// import LeaderboardRankItem from "../LeaderboardRankItem";
import { useEffect } from "react";
// import { AdminApi } from "../../../api/AdminApi";
import { useState } from "react";
// import CoSportSchoolInfoCard from "../CoSportSchoolInfoCard";

// import CoSportSchoolInfoCard from "../components/leaderBoard/CoSportSchoolInfoCard/index.jsx";
const MAIN_FONT = "Noto Sans TC";

const BackgroundMap = {
  blue: leaderBoardBg_1,
  orange: leaderBoardBg_2,
  purple: leaderBoardBg_3,
  green: leaderBoardBg_4,
};

function getYearLabel(year) {
  if (!year) return "";

  let nextYear = parseInt(year) + 1;



  return `${year} - ${nextYear} 學年`;
}

function getSemesterLabel(semester) {
  if (!semester) return "";

  if (semester === "semester1") {
    return "上學期";
  } else if (semester === "semester2") {
    return "下學期";
  } else {
    return "全學年";
  }
}

function getTimeRangeStr(filters) {
  //let timeRangeStr = "";
  return getYearLabel(filters.year) + " / " + getSemesterLabel(filters.dateRangeType);

}

export default function SchoolLeaderboardDisplay({ leaderboardData, filters }) {
  const [localLeaderboardData, setLocalLeaderboardData] = useState(leaderboardData);

  let bgColor = "blue";
  let skillName = leaderboardData?.name_zh || "Skill ??";
  // let timeRangeStr = "Timeslot Caption";
  let skillCode = "";

  let timeRangeStr = getTimeRangeStr(filters);// filters.dateRangeType || "" + filters.year;

  let hasResult = leaderboardData?.result && leaderboardData.result.length > 0;

  let rankInfos = leaderboardData?.result || [];

  // console.debug("SportDisplay: ", leaderboardData);

  const NothingDisplay = () => {
    return (
      <Box
        sx={{
          border: "3px solid #eee",
          borderRadius: "10px",
          boxShadow: " 0 3px 10px  #9ecaed;",
        }}
        my={4}
      >
        <Grid
          container
          justifyContent="center"
          alignItems={"center"}
          py={4}
          px={4}
        >
          <Grid item xs={12}>
            <Typography variant="h2" color={"white"}>
              未有資料
            </Typography>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Box
      align="center"
      pt={6}
      minHeight={"100vh"}
      sx={{
        backgroundImage: `url("${BackgroundMap[bgColor]}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      position="relative"
    >
      <Grid
        container
        direction={"column"}
        justifyContent="center"
        alignItems={"center"}
        rowSpacing={2}
        pb={4}
        mb={4}
        sx={{
          // transform: "rotateY(12deg) rotateZ(-5deg) skewX(-5deg) ",
          // WebkitTransform: "rotateZ(-5deg) skewX(-5deg)" /* Safari & Chrome */,
          // MozTransform:
          //   "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Firefox */,
          // MsTransform:
          //   "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Internet Explorer */,
          // OTransform: "rotateY(12deg) rotateZ(-5deg) skewX(-5deg)" /* Opera */,
        }}
      >
        <Grid item xs={12} align={"center"}>
          {/* <pre>
            {JSON.stringify(leaderboardData, null, 2) }
          </pre> */}
          <Box
            sx={{
              borderBottom: "3px solid #eee",
              boxShadow: " 0 3px 2px -2px  #9ecaed;",
              width: "fit-content",
            }}
          >
            <Typography
              variant={"h1"}
              color={"white"}
              sx={{
                fontFamily: MAIN_FONT,
                fontSize: "68px",
                fontWeight: "900",
                lineHeight: "80px",
                letterSpacing: "0em",
              }}
            >
              {skillName}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant={"h3"}
            color={"white"}
            sx={{
              fontFamily: MAIN_FONT,
              fontSize: "40px",
              fontWeight: "900",
              // lineHeight: "80px",
              letterSpacing: "0em",
            }}
          >
            {timeRangeStr}
          </Typography>
        </Grid>


        {/* No any result */}
        {!hasResult ? (
          <Grid item sx={{ width: "90%" }}>
            <NothingDisplay />
          </Grid>
        ) : null}
        {/* // Leader Display */}


        <Box sx={{}}>
          {/* <pre>{eventID} skillCode: [{skillCode}]</pre>
          <pre>
            {JSON.stringify(localSportLeader, null, 2)}
          </pre> */}
          {/* {
            skillCode !== "" && (
              <CoSportSchoolInfoCard eventID={eventID} skillCode={skillCode} />
            )
          } */}

        </Box>
        <Grid
          container
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={2}
          mt={3}
        >
          {rankInfos.map((_r, index) => (
            <Grid item key={index} sx={{ width: "auto" }}>
              <SchoolLeaderboardRankItem key={`rank-${index}`} content={_r} overall />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
